module.exports = __webpack_public_path__ + "img/step-one.cc352203.png";